import React, { useState, useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';

/**
 * props:
 * - data
 */
function SymbolModal(props) {

    const { formatMessage } = useIntl();
    const t = (id) => formatMessage({ id });

    const DEFAULT_SYMBOL = {
        symbol: '',
        basePrecision: '',
        quotePrecision: '',
        minNotional: '',
        minLotSize: '',
        tickSize: '',
        stepSize: '',
        fStepSize: '',
        fTickSize: '',
        fMinNotional: '',
        fMinLotSize: ''
    }

    const btnClose = useRef('');
    const [error, setError] = useState('');
    const [symbol, setSymbol] = useState(DEFAULT_SYMBOL);

    useEffect(() => {
        if (!props.data) return;
        setSymbol(props.data);
    }, [props.data])

    useEffect(() => {
        const modal = document.getElementById('modalSymbol');
        modal.addEventListener('hidden.bs.modal', (event) => {
            setSymbol({ ...DEFAULT_SYMBOL });
        })
    }, [])

    return (
        <div className="modal fade" id="modalSymbol" tabIndex="-1" role="dialog" aria-labelledby="modalTitleNotify" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <p className="modal-title" id="modalTitleNotify">{t('symbols.viewTitle')}</p>
                        <button ref={btnClose} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="py-3">
                            {/* .gh-grid instead of row/col-md-6: label/value pairs reflow to
                                one column on a narrow modal, and long precision values wrap
                                (text-break) rather than widening the dialog. */}
                            <div className="form-group mb-4">
                                <div className="mb-3">
                                    <label htmlFor="symbol">{t('symbols.symbol')}</label>
                                    <input className="form-control" id="symbol" type="text" placeholder="BTCUSD" defaultValue={symbol.symbol} required disabled />
                                </div>
                                <div className="gh-grid gh-grid-wide mb-3">
                                    <div className="text-break">
                                        <b>{t('symbols.basePrecision')} </b>{symbol.basePrecision}
                                    </div>
                                    <div className="text-break">
                                        <b>{t('symbols.quotePrecision')} </b>{symbol.quotePrecision}
                                    </div>
                                </div>
                                <p><b>{t('symbols.spotRules')}</b></p>
                                <div className="gh-grid gh-grid-wide mb-3">
                                    <div className="text-break">
                                        <b>{t('symbols.minNotionalLabel')} </b>{symbol.minNotional}
                                    </div>
                                    <div className="text-break">
                                        <b>{t('symbols.minLotSizeLabel')} </b>{symbol.minLotSize}
                                    </div>
                                    <div className="text-break">
                                        <b>{t('symbols.tickSize')} </b>{symbol.tickSize}
                                    </div>
                                    <div className="text-break">
                                        <b>{t('symbols.stepSize')} </b>{symbol.stepSize}
                                    </div>
                                </div>
                                {
                                    symbol.fMinNotional
                                        ? (
                                            <React.Fragment>
                                                <hr />
                                                <p className='mt-3'><b>{t('symbols.futuresRules')}</b></p>
                                                <div className="gh-grid gh-grid-wide mb-3">
                                                    <div className="text-break">
                                                        <b>{t('symbols.minNotionalLabel')} </b>{symbol.fMinNotional}
                                                    </div>
                                                    <div className="text-break">
                                                        <b>{t('symbols.minLotSizeLabel')} </b>{symbol.fMinLotSize}
                                                    </div>
                                                    <div className="text-break">
                                                        <b>{t('symbols.tickSize')} </b>{symbol.fTickSize}
                                                    </div>
                                                    <div className="text-break">
                                                        <b>{t('symbols.stepSize')} </b>{symbol.fStepSize}
                                                    </div>
                                                </div>
                                            </React.Fragment>
                                        )
                                        : <React.Fragment></React.Fragment>
                                }
                            </div>
                        </div>
                    </div>
                    {
                        error
                            ? <div className="alert alert-danger">{error}</div>
                            : <React.Fragment></React.Fragment>
                    }
                </div>
            </div>
        </div>
    )
}

export default SymbolModal;
